import '../../scripts/snippets/gift-wrap-modal.js';
import './template-cart.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateCart = (context) => {
  const templateCartSection = context.closest('.shopify-section');
  if (!templateCartSection) return;

  var $form = $(templateCartSection).find('#cart-form');
  if ($form.length <= 0) return;

  $form.find('[type="submit"][name="update"]').on('mousedown', function () {
    $form.off('submit.Parsley');
  });

  // Group by customization

  $('.cart__form__row--product').each(function () {
    var groupId = $(this).attr('data-group');
    $(".cart__form__row--product[data-grouped=false][data-group='" + groupId + "']").wrapAll('<div class="cart__form__products-group">');
    $(".cart__form__row--product[data-group='" + groupId + "']").attr('data-grouped', true);
  });

  // Check gift wrapping

  $('.cart__form__products-group').each(function () {

    if ($(this).find('.cart__form__row--product[data-giftwrap=true]').length == 0) {
      $('.gift-modal-opener', $(this)).addClass('visible');
    } else {
      $('.gift-modal-opener', $(this)).removeClass('visible');
    }
  });

  const updateCartPage = (updates) => {
    $(context).addClass('is-loading');

    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.items.length <= 0) {
          location.reload();
        } else {
          var selectorToRemove = '.cart__form__row--product';
          data.items.forEach(lineItem => {
            selectorToRemove += ':not(#line-item--' + lineItem.id + '--' + lineItem.properties['_UniqueId'] + ')';
          });
          const $totalPrice = $form.find('[data-total-price]');
          if ($totalPrice.length > 0) {
            $totalPrice.text(theme.Currency.formatMoney(data.total_price, theme.strings.moneyFormat));
          }
          const $toRemove = $form.find(selectorToRemove);
          if ($toRemove.length > 0) {
            $toRemove.remove();
          }
          $(context).removeClass('is-loading');
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  $form.find('.cart__form__meta__remove a').on('click', function (e) {
    e.preventDefault();

    const parent = $(this).parents('.cart__form__products-group');
    const itemKey = $(this).parents('.cart__form__row--product').attr('data-key');
    const selectorMinicartToRemove = '.minicart__product[data-key="' + itemKey + '"]';
    const selectorMinicartBubble = '.cart-link__bubble';

    let updates = {
      [itemKey]: 0,
    };

    if (!$(this).hasClass('giftwrap')) {
      const customizationKey = parent.find('.cart__form__row--product[data-customization=true]')?.attr('data-key');
      if (customizationKey) {
        updates[customizationKey] = 0;
      }

      const giftwrapKey = parent.find('.cart__form__row--product[data-giftwrap=true]')?.attr('data-key');
      if (giftwrapKey) {
        updates[giftwrapKey] = 0;
      }
    } else {
      $('.gift-modal-opener', parent).addClass('visible');
    }

    if ($(selectorMinicartToRemove).length) {
      $(selectorMinicartToRemove).remove();
      const minicartCounter = parseInt($(selectorMinicartBubble).html());
      $(selectorMinicartBubble).html(minicartCounter - 1);
    }

    updateCartPage(updates);
  });
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.cart-section'), (el) => {
    window.dAgency.initTemplateCart(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.cart-section'), (el) => {
      window.dAgency.initTemplateCart(el);
    });
  });
}
